export default __webpack_public_path__ + "static/media/art6.51d95841.jpeg";